import { Component, OnInit ,Input} from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {EditBidModalComponent} from 'src/app/shared/components/edit-bid-modal/edit-bid-modal.component';
import{QuoteSelectProductsEditBidComponent} from 'src/app/shared/components/quote-select-products-edit-bid/quote-select-products-edit-bid.component'
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgFor, NgClass, NgIf, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-quote-select-products',
    templateUrl: './quote-select-products.component.html',
    styleUrls: ['./quote-select-products.component.scss'],
    imports: [NgFor, NgClass, FormsModule, NgIf, DecimalPipe, DatePipe, I18nModule]
})
export class QuoteSelectProductsComponent implements OnInit {
  @Input() quantity:any;
  private modalRef: NgbModalRef;
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  @Input() code:any;
  @Input() price:number;
  @Input() tabName: any;
  @Input() indexPrice:number;
  @Input() productsInfo: any;
  @Input() indexValue: any;
  productInfo:any=[];
  tabValue: any;
  material1: boolean =true;
  public checkMaterial1:boolean;
  biddingTerms = '';
  requestParams: any;
  productValue:any;
  parameter=[];
  constructor(public ActiveModal: NgbActiveModal,private customProductService: CustomProductsService,public ModalService:NgbModal,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.indexValue = 0;
    this.productInfo=this.productsInfo && this.productsInfo.quoteEntries;
    this.productInfo.map(val=>{
      if(val  && val.checked === undefined){
        val.checked = false
      }else if(val  && val.checked === true){
        val.checked = true
      }else if(val  && val.checked === false){
        val.checked = false
      }
      if(val.relativePrice){
        val.relPrice = val.relativePrice?.value;
      }else{
        val.premDiscount = val.premiumDiscount?.value;
      }
    })
   // this.modifyResponsetoCombinedList();
  }
  close(): any {
    this.productInfo.map(val=>{
        val.checked = false
    })
    this.ActiveModal.close();
  }
  onCheckboxChange(e,event) {
    let checked = event.target.checked;
    if(checked){
    if (e) {
     this.parameter.push(e);
    console.log(this.parameter);
    }else{
      this.parameter.push();
      console.log(this.parameter);
    }
  }
  if(!checked){
    const index = this.parameter.findIndex(x => x.value === e);
    this.parameter.splice(index, 1);
  }
  this.parameter.map(val=>{
    if(val.relativePrice){
      val.relPrice = val.relativePrice?.value;
    }else{
      val.premDiscount = val.premiumDiscount?.value;
    }
  })
  }
      Openmodal(){
        this.ActiveModal.close();
        if(this.parameter.length > 1){
        //   if(this.parameter[this.indexValue].pricingOptionsEnum.length>1){
        //   const ModalRef = this.modalService.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'sm'});
        //   ModalRef.componentInstance.code =this.productsInfo;
        //   ModalRef.componentInstance.price = '0';
        //   ModalRef.componentInstance.indexPrice = '0';
        //   ModalRef.componentInstance.index =this.parameter;
        //  ModalRef.componentInstance.indexValue = this.indexValue;
        // this.productSelect[this.indexValue].pricingOptionsEnum[0].pricingOptions='';
        // }
        
          const ModalRef = this.modalService.open(QuoteSelectProductsEditBidComponent,{centered: true,size:'md'});
          ModalRef.componentInstance.code =this.productsInfo;
          console.log(this.productsInfo,'pf')
          if(this.parameter[this.indexValue].pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'){
            ModalRef.componentInstance.price = this.parameter[this.indexValue].relativePrice.value || '0';
            ModalRef.componentInstance.price1 = this.parameter[this.indexValue].relPrice || '0';
          }
          if(this.parameter[this.indexValue].pricingOptionsEnum[0].pricingOptions!='FIXED_PRICE'){
            ModalRef.componentInstance.indexPrice = this.parameter[this.indexValue].premiumDiscount?.value ||'0';
            ModalRef.componentInstance.indexPrice1 = this.parameter[this.indexValue].premDiscount ||'0';
          }
          ModalRef.componentInstance.index =this.parameter;
         ModalRef.componentInstance.indexValue = this.indexValue;
         if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
         ModalRef.componentInstance.quantity = this.parameter[this.indexValue].quantity;
         }
        }
        if(this.parameter.length <= 1){
          if(this.parameter[this.indexValue].pricingOptionsEnum.length==1){
            const ModalRef = this.ModalService.open(EditBidModalComponent,{centered: true,size:'md'});
            ModalRef.componentInstance.productsEntry = this.parameter;
            ModalRef.componentInstance.selectProduct = this.productsInfo;
            if( this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
            ModalRef.componentInstance.quantity = this.quantity;
            }
          }if(this.parameter[this.indexValue].pricingOptionsEnum.length>1){
          const ModalRef = this.ModalService.open(EditBidModalComponent,{centered: true,size:'md'});
          ModalRef.componentInstance.productsEntry = this.parameter;
          ModalRef.componentInstance.selectProduct = this.productsInfo;
          if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
          ModalRef.componentInstance.quantity = this.quantity;
          }
         // this.productSelect[this.indexValue].pricingOptionsEnum[0].pricingOptions='';
        }
        }
          }

          groupBy = (arr, property) => {
            return arr.reduce((acc, cur) => {
              acc[cur[property]] = [...acc[cur[property]] || [], cur];
              return acc;
            }, {});
          }
          
          // modifyResponsetoCombinedList(){
          //  // for(let tenders of this.tenderQuotesListData){
          //     if(this.productsInfo.quoteEntries?.length>1){
          //       var tendersListithSetInfo = this.productsInfo.quoteEntries.filter(x=>(x.set!='' && x.set!=undefined));
          //       if(tendersListithSetInfo?.length>0){
          //         var ObjectWhichContainsSetInfo= this.groupBy(tendersListithSetInfo,'set');
          //         var groupList=[];
          //         for(let item in ObjectWhichContainsSetInfo){
          //           var newName = ''
          //           var mainObject:any = {};
          //           var mainAvailable = false;
          //           var OptionalTendersWIthoutAnyMain = [];
          //           var childList = []
          //           tendersListithSetInfo.forEach(element => {
          //             if(item == element.set){
          //               newName = newName+element.productName+' or ';
          //               element.newName = newName;
          //               if(element.materialOption == 'MAIN'){
          //                 mainAvailable = true;
          //                 mainObject = Object.assign(element);
          //               }
          //               else if(mainAvailable == false){
          //                 element.newName = undefined;
          //                 OptionalTendersWIthoutAnyMain.push(element);
          //               }
                        
          //               mainObject.newName = newName;
          //               childList.push(element);
          //             }
          //           });
          //           mainObject.newName = mainObject.newName.substring(0,mainObject.newName.length-4);
          //           mainObject.childList = childList;
          //           if(mainAvailable){
          //             groupList.push(mainObject);
          //           }
          //           if(groupList.length>0){
          //             this.productsInfo.groupTenders = groupList;
          //           }else{
          //             this.productsInfo.groupTenders = [];
          //           }
          //           this.productsInfo.IndividualTenders = this.productsInfo.quoteEntries.filter(x=>(x.set=='' || x.set == undefined));
                   
          //           if(OptionalTendersWIthoutAnyMain?.length>0){
          //             this.productsInfo.IndividualTenders = this.productsInfo.IndividualTenders.concat(OptionalTendersWIthoutAnyMain);
          //           }
          //         }
          //         this.productsInfo.combinedTenders=[...this.productsInfo?.groupTenders,...this.productsInfo.IndividualTenders];
          //       }
          //       else{
          //         this.productsInfo.IndividualTenders = this.productsInfo.quoteEntries
          //         this.productsInfo.combinedTenders=this.productsInfo.IndividualTenders
        
          //       }
          //     }
          //     else{
          //       this.productsInfo.IndividualTenders = this.productsInfo.quoteEntries
          //       this.productsInfo.combinedTenders=this.productsInfo.IndividualTenders
          //     }
          //    // console.log(this.productsInfo,'tenders');
          //  // }
            
          // }
}
